import React from 'react';
import ActionButton from '../common/ActionButton';
import Tippy from '@tippyjs/react';
import { PlusIcon, XMarkIcon } from '@heroicons/react/24/solid';

const ActionControls = ({
  isSelectMode,
  onToggleSelectMode,
  selectedCount,
  maxSelection,
  onBulkAdd,
  onCancelSelectMode,
  isBulkAdding,
  bulkAddDisabled,
  bulkAddTooltip,
}) => {
  const selectMultipleButton = (
    <ActionButton
      onClick={onToggleSelectMode}
      disabled={bulkAddDisabled}
      variant="glassy"
      color="orange"
      className="w-full px-3 py-2 text-sm font-medium rounded-xl text-white"
    >
      <span className="flex items-center justify-center gap-1.5 whitespace-nowrap">
        <PlusIcon className="h-4 w-4 flex-shrink-0" />
        <span className="truncate">Select Multiple</span>
      </span>
    </ActionButton>
  );

  return (
    <div className="space-y-2 max-w-full">
      {isSelectMode ? (
        <>
          {/* Selection Counter - Always glassy */}
          <div
            className="
            relative rounded-lg backdrop-blur-sm border border-border
            bg-background-secondary/30 p-2 text-center
            "
          >
            <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent rounded-lg dark:from-white/5" />
            <div className="relative">
              <div className="text-sm font-bold text-content-primary">
                {selectedCount} / {maxSelection}
              </div>
              <div className="text-xs font-medium text-content-primary uppercase tracking-wide">selected</div>
            </div>
          </div>

          {/* Add Selected Button - Glassy only on mobile */}
          <ActionButton
            onClick={onBulkAdd}
            loading={isBulkAdding}
            disabled={selectedCount === 0 || bulkAddDisabled}
            variant="glassy"
            color="green"
            className="w-full px-3 py-2 text-sm font-medium rounded-xl text-white"
          >
            <span className="flex items-center justify-center gap-1.5 whitespace-nowrap">
              <PlusIcon className="h-4 w-4 flex-shrink-0" />
              <span className="truncate">{`Add Selected (${selectedCount})`}</span>
            </span>
          </ActionButton>

          {/* Cancel Button - NOT glassy on mobile dark theme */}
          <ActionButton
            onClick={onCancelSelectMode}
            disabled={isBulkAdding}
            variant="glassy"
            color="neutral"
            className="w-full px-3 py-2 text-sm font-medium rounded-xl text-white"
          >
            <span className="flex items-center justify-center gap-1.5 whitespace-nowrap">
              <XMarkIcon className="h-4 w-4 flex-shrink-0" />
              <span className="truncate">Cancel</span>
            </span>
          </ActionButton>
        </>
      ) : bulkAddDisabled ? (
        <Tippy content={bulkAddTooltip} placement="top">
          <span className="w-full block">{selectMultipleButton}</span>
        </Tippy>
      ) : (
        selectMultipleButton
      )}
    </div>
  );
};

export default ActionControls;
